<template>
    <div class="dropdown-container">
        <div class="dropdown-btn">
            <slot name="dropdown-btn"></slot>
        </div>
        <div ref="dropdown" :style="styles" class="dropdown-content">
            <slot v-if="dropdownOpen" name="dropdown-content"></slot>
        </div>
    </div>
</template>
<script>
    import { usePopup } from '@/composables/ui/usePopup'

    export default {
        name: 'BaseDropdown',
        props: {
            styles: {
                required: false,
                type: Object,
                default: () => ({})
            }
        },
        setup() {
            const { popup: dropdown, popupOpen: dropdownOpen } = usePopup()

            return {
                dropdown,
                dropdownOpen
            }
        }
    }
</script>
<style lang="scss" scoped>
    .dropdown-container {
        .dropdown-content {
            position: absolute;
            z-index: 1;
            overflow-y: scroll;
            padding: 16px;
            border: 1.5px solid #8b8b8b;
            border-radius: 12px;
            background: #262626;
        }
        .dropdown-content::-webkit-scrollbar {
            width: 8px;
        }
        .dropdown-content::-webkit-scrollbar-track {
            background-color: none;
        }
        .dropdown-content::-webkit-scrollbar-thumb {
            max-height: 64px;
            border-radius: 8px;
            background: #8b8b8b;
        }
    }
</style>
